module.exports = __webpack_public_path__ + "static/media/youtube-d.24563d16.svg";